const parseOptimizelyDecisionsCookie = (cookieString) => {
	if (!cookieString || typeof cookieString !== "string") return {};

	return cookieString.split(",").reduce((acc, part) => {
		const [key, value] = part.split(":");
		acc[key] = value;
		return acc;
	}, {});
};

export { parseOptimizelyDecisionsCookie }